import React, { useState, useEffect, useRef } from 'react';
import styles from './TextRotator.module.css';

export default function TextRotator({ items = [], interval = 4000 }) {
  const [index, setIndex] = useState(0);
  const [prevIndex, setPrevIndex] = useState(null);
  const indexRef = useRef(0);

  // Keep a ref in sync so the interval always reads the latest index
  // without having to re-create the timer on every tick.
  useEffect(
    () => {
      indexRef.current = index;
    },
    [index]
  );

  useEffect(
    () => {
      if (items.length <= 1) return;
      const id = setInterval(() => {
        const { current } = indexRef;
        setPrevIndex(current); // outgoing line
        setIndex((current + 1) % items.length); // incoming line
      }, interval);
      // eslint-disable-next-line consistent-return
      return () => clearInterval(id);
    },
    [items.length, interval]
  );

  return (
    <div className={styles.rotator}>
      {/* invisible, in-flow copy that gives the box its width + height */}
      <span className={styles.sizer} aria-hidden="true">
        {items[index]}
      </span>

      {prevIndex !== null && (
        <span
          key={`out-${prevIndex}`}
          className={`${styles.line} ${styles.exit}`}
          onAnimationEnd={() => setPrevIndex(null)}
        >
          {items[prevIndex]}
        </span>
      )}
      <span
        key={`in-${index}`}
        className={`${styles.line} ${prevIndex !== null ? styles.enter : ''}`}
      >
        {items[index]}
      </span>
    </div>
  );
}
